export enum ManageCategoryCommonEnum {
  DeactivateCategory = 1,
  Purchase = 2,
  AssignGrades = 3,
  AssignTax = 4,
  CategoryIsActive = 5,
  AccountingCode = 6,
  TaxRate = 7,
  DuplicateCategory = 8,
  CategoryEdited = 9,
  BulkDeactivateCategory = 10,
  BulkAccTax = 11,
  BulkDeactivateCategoryWhenSupplierAssigned = 12,
  BulkActivateCategory = 13,
  EntCategoryAlert = 14,
  GooglePackageCategoryAlert = 15,
}